document.addEventListener('DOMContentLoaded', function () {
  const novedades = document.querySelector(
    '.collapsible-tabs:has(#faq-novedades-para-distribuidores)'
  );

  if (!novedades) return;

  const accordions = novedades.querySelectorAll('details.disclosure');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
      if (!accordion.open) return;

      accordions.forEach((otherAccordion) => {
        if (otherAccordion !== accordion && otherAccordion.open) {
          otherAccordion.removeAttribute('open');
        }
      });
    });
  });
});